import './../../scss/components/axiosError.scss'

const AxiosError: React.FC = () => {
  return (
    <div className="axios_error">
      <div className="txt">
        <h1>
          <strong>
            Woops!
          </strong> 길을 잃었어요 !</h1>
        <p>
          이곳에서는 원하시는 정보를 찾을 수 없어요<br/>
          &#128270; 로고 혹은 돋보기를 클릭해 정보를 다시 찾아보세요
        </p>
      </div>
    </div>
  );
}

export default AxiosError;